import React from 'react'

const Option = ({ option, handleSelection, selectedOption }) => {
    return (
        <div class="option">
            <label>
                <input type="radio" checked={selectedOption === option} name={option} onChange={(e) => handleSelection(e.target.name)} />
                <span>{option}</span>
            </label>
        </div>
    )
}

export default Option